<template>
  <layout>
    <div class="page-view">
      <banner
        :img="contList.picUrl"
        :title="contList.menuName"
        :subtitle="contList.menuNameEn" />
      <div
        class="scheme"
        :key="c.id"
        v-for="c in contList.menuModule">
        <f-title
          :title="c.title"
          :subtitle="c.titleEn" />
        <div class="scheme-desc">{{ c.content }}</div>
        <div class="flex-box">
          <div
            class="scheme-modules"
            v-for="d in c.detailsList"
            @click="goGoveService(d)"
            :key="d.id">
            <img
              :src="d.imgUrl"
              alt="" />
            <div class="scheme-modules-cont">
              <div class="title">{{ d.title }}</div>
              <div class="more">
                了解更多<span class="iconfont icon-right-1-copy"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import FTitle from '@/components/title.vue';
import Layout from '@/components/moblie/Layout.vue';
import Banner from '@/components/banner.vue';
export default {
  components: { Layout, Banner, FTitle },
  props: {
    contList: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goGoveService(row) {
      this.$router.push({
        name: row.routingPath,
        params: { id: row.id },
      });
      this.$store.commit('changeTabCheck', {
        idNum: row.idNum,
        sumName: '',
      });
      this.$store.state.enterp_somFlg = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  $container-width: 343px;
  .page-view {
    .scheme {
      width: $container-width;
      margin: 20px auto;
      &-desc {
        font-weight: 400;
        font-size: 9px;
        color: #666666;
        text-align: center;
        margin-bottom: 27px;
      }
      &-modules {
        position: relative;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          margin-bottom: 25px;
        }
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        &-cont {
          position: absolute;
          font-weight: 500;
          font-size: 15px;
          color: #ffffff;
          left: 15px;
          bottom: 17px;
          .more,
          .iconfont {
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
            opacity: 0.8;
          }
        }
      }
      &-palteB {
        &-item {
          height: 160px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      &-palteA {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: $container-width;
        .item {
          flex-shrink: 0;
          margin-bottom: 20px;
          width: 166px;
          .kv {
            width: 100%;
            height: 120px;
            margin-bottom: 4px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .cont {
            background: #f5f5f6;
            padding: 4px 5px;
            &-title {
              font-weight: 500;
              font-size: 13px;
              color: #151a23;
            }
            &-desc {
              font-weight: 300;
              font-size: 10px;
              color: #151a23;
            }
          }
        }
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .page-view {
    .scheme {
      width: $container-width;
      margin: 20px auto;
      &-desc {
        font-weight: 400;
        font-size: 9px;
        color: #666666;
        text-align: center;
        margin-bottom: 27px;
      }
      .flex-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-modules {
        position: relative;
        width: 32%;
        margin-bottom: 25px;

        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        &-cont {
          position: absolute;
          font-weight: 500;
          font-size: 15px;
          color: #ffffff;
          left: 15px;
          bottom: 17px;
          .more,
          .iconfont {
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
            opacity: 0.8;
          }
        }
      }
      &-palteB {
        &-item {
          height: 160px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      &-palteA {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: $container-width;
        .item {
          flex-shrink: 0;
          margin-bottom: 20px;
          width: 166px;
          .kv {
            width: 100%;
            height: 120px;
            margin-bottom: 4px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .cont {
            background: #f5f5f6;
            padding: 4px 5px;
            &-title {
              font-weight: 500;
              font-size: 13px;
              color: #151a23;
            }
            &-desc {
              font-weight: 300;
              font-size: 10px;
              color: #151a23;
            }
          }
        }
      }
    }
  }
}
</style>
